import React from 'react';

import {PermissionsTable, PermissionsTableSkeleton} from 'src/admin-rights-service/components/permissions-table';
import {Skeleton} from 'src/components/skeleton';

type Props = {
    isLoading: boolean,
    adminPermissions: string[],
    defaultAdminPermissions: string[],
    setAdminPermissions: React.Dispatch<React.SetStateAction<string[]>>,
    disabled?: boolean,
};

export const AdminPermissions = ({
    isLoading, adminPermissions, defaultAdminPermissions, setAdminPermissions, disabled,
}: Props) => (
    <Skeleton shown={isLoading} view={<PermissionsTableSkeleton/>}>
        <PermissionsTable
            disabled={disabled}
            permissions={adminPermissions}
            defaultPermissions={defaultAdminPermissions}
            setPermissions={setAdminPermissions}
        />
    </Skeleton>
);
